export default class Inspiration {
    constructor() {
        this.inspirationVideos 		= document.querySelectorAll('.tile--inspiration');
        this.inspirationLightboxes 	= document.querySelectorAll('.inspiration-video');

        this.inspirationVideos && this.inspirationVideos.forEach((inspirationVideo) => {
            inspirationVideo.addEventListener("click", (event) => {
                let cloned = inspirationVideo.querySelector('.inspiration-video');
                document.querySelector('main').appendChild(cloned);
                cloned.classList.add('inspiration-video--open');

                document.body.classList.add('freeze');
                if(window.app.smoother) {
                    window.app.smoother.paused(true);
                }
            });
        })

        this.inspirationLightboxes && this.inspirationLightboxes.forEach((inspirationLightbox) => {
            inspirationLightbox.addEventListener("click", (event) => {
                if (!event.target.closest('.inspiration-video__content')) {
                    let postID = inspirationLightbox.dataset.inspiration;
                    document.querySelector('.tile--inspiration[data-inspiration="'+postID+'"]').appendChild(inspirationLightbox);
                    inspirationLightbox.classList.remove('inspiration-video--open');

					document.body.classList.remove('freeze');
					window.app.smoother.paused(false);
                }
            });
        })
    }
}